import type { ButtonProps } from '@music-vine/cadence/ui';
import { Button } from '@music-vine/cadence/ui';
import { useOpenPartnerApplication } from '@/components/PartnerProgram/useOpenPartnerApplication';
import { addGAEvent } from '@/utils/analytics/google/addGAEvent';
interface PartnerButtonProps extends ButtonProps {
  children: React.ReactNode;
}
const PartnerButton: React.FC<PartnerButtonProps> = ({
  children,
  onClick,
  ...props
}) => {
  const openPartnerApplication = useOpenPartnerApplication();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    addGAEvent('click-partner-program-apply', {
      category: 'partner-program',
      value: 'apply-now'
    });
    openPartnerApplication();
  };
  return <Button onClick={handleClick} size="lg" type="button" variant="brand" {...props} data-sentry-element="Button" data-sentry-component="PartnerButton" data-sentry-source-file="PartnerButton.tsx">
      {children}
    </Button>;
};
export default PartnerButton;